import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import styles from './LollipopPlotDataPointArrow.style';
const LollipopPlotDataPointArrow = memo(function LollipopPlotDataPointArrow({ x, y }) {
    return (_jsx("path", { style: styles.arrow, d: `M ${x} ${y} m 0 -20 v 9 l 3 -3 m -3 3 l -3 -3 z` }, void 0));
});
export default LollipopPlotDataPointArrow;
